/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TaskWorkflowItemPicklistOption
 */
export interface TaskWorkflowItemPicklistOption {
    /**
     * 
     */
    task_workflow_item_id: string | null;
    /**
     * 
     */
    task_workflow_item_org_configuration_id: string | null;
    /**
     * 
     */
    name: string;
}

/**
 * Check if a given object implements the TaskWorkflowItemPicklistOption interface.
 */
export function instanceOfTaskWorkflowItemPicklistOption(value: object): value is TaskWorkflowItemPicklistOption {
    if (!('task_workflow_item_id' in value) || value['task_workflow_item_id'] === undefined) return false;
    if (!('task_workflow_item_org_configuration_id' in value) || value['task_workflow_item_org_configuration_id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function TaskWorkflowItemPicklistOptionFromJSON(json: any): TaskWorkflowItemPicklistOption {
    return TaskWorkflowItemPicklistOptionFromJSONTyped(json, false);
}

export function TaskWorkflowItemPicklistOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskWorkflowItemPicklistOption {
    if (json == null) {
        return json;
    }
    return {
        
        'task_workflow_item_id': json['task_workflow_item_id'],
        'task_workflow_item_org_configuration_id': json['task_workflow_item_org_configuration_id'],
        'name': json['name'],
    };
}

export function TaskWorkflowItemPicklistOptionToJSON(json: any): TaskWorkflowItemPicklistOption {
    return TaskWorkflowItemPicklistOptionToJSONTyped(json, false);
}

export function TaskWorkflowItemPicklistOptionToJSONTyped(value?: TaskWorkflowItemPicklistOption | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'task_workflow_item_id': value['task_workflow_item_id'],
        'task_workflow_item_org_configuration_id': value['task_workflow_item_org_configuration_id'],
        'name': value['name'],
    };
}

